import {useCallback, useEffect, useState} from "react";

import {useAppDispatch} from "../../store/hooks";
import {setSemanticSearchHasConversation} from "../state/semantic_search_modal_slice";
import {GetSemanticSearchStoreResponseDto} from "../types/GetSemanticSearchStoreResponseDto";
import {PostSemanticSearchStorePayload} from "../types/PostSemanticSearchStorePayload";

const SEMANTIC_SEARCH_STORAGE_KEY = "semantic_search_conversation_history";

const getHistoryFromStorage = (): GetSemanticSearchStoreResponseDto => {
    try {
        const stored = localStorage.getItem(SEMANTIC_SEARCH_STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored) as GetSemanticSearchStoreResponseDto;
        }
    } catch (error) {
        console.error("Failed to load semantic search history from localStorage:", error);
    }
    return [];
};

export function useSemanticSearchLocalStorage() {
    const dispatch = useAppDispatch();

    const [history, setHistory] = useState<GetSemanticSearchStoreResponseDto>([]);
    const [isLoading, setIsLoading] = useState(true);

    const loadHistory = useCallback(() => {
        const loadedHistory = getHistoryFromStorage();

        setHistory(loadedHistory);
        setIsLoading(false);
        dispatch(setSemanticSearchHasConversation(loadedHistory.length > 0));
    }, [dispatch]);

    useEffect(() => {
        loadHistory();

        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === SEMANTIC_SEARCH_STORAGE_KEY) {
                loadHistory();
            }
        };

        window.addEventListener("storage", handleStorageChange);

        const handleCustomStorageChange = () => {
            loadHistory();
        };

        window.addEventListener("semanticSearchHistoryUpdate", handleCustomStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("semanticSearchHistoryUpdate", handleCustomStorageChange);
        };
    }, [loadHistory]);

    const addMessage = useCallback(
        (message: PostSemanticSearchStorePayload) => {
            const currentHistory = getHistoryFromStorage();
            const newHistory = [
                ...currentHistory,
                {
                    type: message.type,
                    text: message.text,
                    results: message.results || [],
                    offer_signup: message.offer_signup
                }
            ];

            try {
                localStorage.setItem(SEMANTIC_SEARCH_STORAGE_KEY, JSON.stringify(newHistory));
                setHistory(newHistory);

                dispatch(setSemanticSearchHasConversation(newHistory.length > 0));
                window.dispatchEvent(new Event("semanticSearchHistoryUpdate"));
            } catch (error) {
                console.error("Failed to save semantic search history to localStorage:", error);
            }
        },
        [dispatch]
    );

    const clearHistory = useCallback(() => {
        try {
            localStorage.removeItem(SEMANTIC_SEARCH_STORAGE_KEY);

            setHistory([]);
            dispatch(setSemanticSearchHasConversation(false));

            window.dispatchEvent(new Event("semanticSearchHistoryUpdate"));
        } catch (error) {
            console.error("Failed to clear semantic search history from localStorage:", error);
        }
    }, [dispatch]);

    return {
        history,
        isLoading,
        addMessage,
        clearHistory
    };
}
import {useCallback, useEffect, useState} from "react";

import {useAppDispatch} from "../../store/hooks";
import {setSemanticSearchHasConversation} from "../state/semantic_search_modal_slice";
import {GetSemanticSearchStoreResponseDto} from "../types/GetSemanticSearchStoreResponseDto";
import {PostSemanticSearchStorePayload} from "../types/PostSemanticSearchStorePayload";

const SEMANTIC_SEARCH_STORAGE_KEY = "semantic_search_conversation_history";

const getHistoryFromStorage = (): GetSemanticSearchStoreResponseDto => {
    try {
        const stored = localStorage.getItem(SEMANTIC_SEARCH_STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored) as GetSemanticSearchStoreResponseDto;
        }
    } catch (error) {
        console.error("Failed to load semantic search history from localStorage:", error);
    }
    return [];
};

export function useSemanticSearchLocalStorage() {
    const dispatch = useAppDispatch();

    const [history, setHistory] = useState<GetSemanticSearchStoreResponseDto>([]);
    const [isLoading, setIsLoading] = useState(true);

    const loadHistory = useCallback(() => {
        const loadedHistory = getHistoryFromStorage();

        setHistory(loadedHistory);
        setIsLoading(false);
        dispatch(setSemanticSearchHasConversation(loadedHistory.length > 0));
    }, [dispatch]);

    useEffect(() => {
        loadHistory();

        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === SEMANTIC_SEARCH_STORAGE_KEY) {
                loadHistory();
            }
        };

        window.addEventListener("storage", handleStorageChange);

        const handleCustomStorageChange = () => {
            loadHistory();
        };

        window.addEventListener("semanticSearchHistoryUpdate", handleCustomStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("semanticSearchHistoryUpdate", handleCustomStorageChange);
        };
    }, [loadHistory]);

    const addMessage = useCallback(
        (message: PostSemanticSearchStorePayload) => {
            const currentHistory = getHistoryFromStorage();
            const newHistory = [
                ...currentHistory,
                {
                    type: message.type,
                    text: message.text,
                    results: message.results || [],
                    offer_signup: message.offer_signup
                }
            ];

            try {
                localStorage.setItem(SEMANTIC_SEARCH_STORAGE_KEY, JSON.stringify(newHistory));
                setHistory(newHistory);

                dispatch(setSemanticSearchHasConversation(newHistory.length > 0));
                window.dispatchEvent(new Event("semanticSearchHistoryUpdate"));
            } catch (error) {
                console.error("Failed to save semantic search history to localStorage:", error);
            }
        },
        [dispatch]
    );

    const clearHistory = useCallback(() => {
        try {
            localStorage.removeItem(SEMANTIC_SEARCH_STORAGE_KEY);

            setHistory([]);
            dispatch(setSemanticSearchHasConversation(false));

            window.dispatchEvent(new Event("semanticSearchHistoryUpdate"));
        } catch (error) {
            console.error("Failed to clear semantic search history from localStorage:", error);
        }
    }, [dispatch]);

    return {
        history,
        isLoading,
        addMessage,
        clearHistory
    };
}
